import React from 'react';
import { Link } from 'react-router-dom';
import { classes } from '../../../data-catalog-shared';

import {
  activeLineageItemType,
  cartoucheIconButtonClass,
  cartoucheIconStyle,
  lineageIconButtonClass,
} from '../style/LineageCartoucheStyles';
import { HoverComponent } from '../widgets/HoverComponent';
import { getIconForContentType, IconType, LineageItemType } from './LineageItemType';

export interface LineageIconButtonProps {
  readonly isCurrentPane?: boolean;
  readonly linkHref: string;
  readonly lineageItemType: LineageItemType;
  readonly buttonAltText: string;
  readonly inCartouche?: boolean;
}

// Renders a clickable link icon for the Lineage Nav
export class LineageIconButton extends React.Component<LineageIconButtonProps> {

  public override render(): JSX.Element {
    const iconClasses: string = this.props.isCurrentPane ? classes(cartoucheIconStyle, activeLineageItemType) : cartoucheIconStyle;
    const NormalIcon = getIconForContentType(this.props.lineageItemType, this.props.isCurrentPane ? IconType.white : IconType.inactive);
    const HoverIcon = getIconForContentType(this.props.lineageItemType, this.props.isCurrentPane ? IconType.white : IconType.active);

    return (
      <Link
        to={this.props.linkHref}
        className={this.props.inCartouche ? cartoucheIconButtonClass : lineageIconButtonClass}
      >
        <HoverComponent
          normalElement={<NormalIcon className={iconClasses} />}
          hoverElement={<HoverIcon className={iconClasses} />}
          altText={this.props.buttonAltText}
        />
      </Link>
    );
  }

}
